import { useState } from 'react'
import type { Item } from 'typings'
import { useFetch } from './useFetch'
import { assertFulfilled } from './utils'

type CollectionResponse = {
  Id: number
  Name: string
}

export function useCollectionsImport() {
  const [loading, setLoading] = useState(false)

  const { fetcherWrapper } = useFetch()

  function getCollection(id: string): Promise<Item> {
    const url = new URL(
      `/api/proxy/catalog/pvt/collection//${id}`,
      window.location.origin
    )

    return fetcherWrapper(url)
      .then((r) => {
        if (r.status === 404) return Promise.reject('Not found')
        if (!r.ok) return Promise.reject('Error retrieving collection')

        return r.json()
      })
      .then((response: CollectionResponse) => ({
        id: String(response.Id),
        name: response.Name,
      }))
  }

  async function importCollections(
    ids: string[]
  ): Promise<{ items: Item[]; found: number; notFound: number }> {
    setLoading(true)

    const promises = ids.map((id) => getCollection(id))

    const collections = await Promise.allSettled(promises).then((resuls) => {
      return resuls.filter(assertFulfilled).map((r) => r.value)
    })

    setLoading(false)

    return {
      found: collections.length,
      notFound: ids.length - collections.length,
      items: collections,
    }
  }

  return { importCollections, loading }
}
